import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Section } from './Section';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section background="white" labelledBy="faq-heading" data-id="element-92" data-mp="1gcxsoqzdze2y">
      <h2 id="faq-heading" className="text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-93" data-mp="1geiki8ubgix4">
        Questions, answered
      </h2>

      <ul className="mx-auto mt-12 max-w-3xl divide-y divide-sage/15 border-y border-sage/15" data-id="element-94" data-mp="291w9nkrrwa6o">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.q} data-id="element-95" data-mp="1z2nl57fofnrp" data-mpi={index}>
              <h3 data-id="element-96" data-mp="1z5jiatjpa8f3">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} className="flex w-full items-start justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage" data-id="element-97" data-mp="smv3cimuwm81">
                  <span className="font-sans text-[16px] font-semibold leading-snug text-ink sm:text-[17px]" data-id="element-98" data-mp="fiytg3nqea7y">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-sage transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={1.75} aria-hidden="true" data-id="element-99" data-mp="6qwu68peezz9" />
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-100" data-mp="1q953skqct7o">
                {isOpen && <motion.div key="panel" id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-101" data-mp="3jyi210apml7i">
                    <p className="pb-6 pr-10 font-sans text-[16px] leading-[1.65] text-ink-soft" data-id="element-102" data-mp="1fpvjj0ue0fed">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}